/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-else-return */
import CommonCollapse from 'components/common/CommonCollapse';
import { splitNameFromUrl } from 'helper/utils';
import moment from 'moment';
import {
  checkDispatched,
  checkInProgress,
  checkLoading,
  checkPending,
  deliveryStatus,
} from 'pages/Orders/constant';
import React from 'react';
import { BsCheckCircleFill } from 'react-icons/bs';
import { Button, Col, Label, List, ListInlineItem, Row } from 'reactstrap';
import { currencyToLocal } from 'utils/constants';

const DeliveryStatus = ({ logistic }) => {
  const {
    transportName,
    id,
    vehicleNumber,
    driverName,
    driverNumber,
    callingCode,
    transportLR,
    vehicleNumberImage,
    loadingCharges,
    otherCharges,
    freight,
    weightSlipDoc,
    loadingImage,
    orderLogisticStatus,
    deliveryDate,
    rateUnit,
    cancellationReason,
  } = logistic;
  const downloadImage = async (imageUrl, imageName) => {
    if (!imageUrl) return '';
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const filename = imageName;
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  return (
    <CommonCollapse heading="Vehicle" id key={id}>
      <div className="d-sm-flex justify-content-end">
        <span className="f-12 fw-medium">
          Delivery Date :{' '}
          {(deliveryDate && moment(deliveryDate).format('D MMM YYYY')) || 'N/A'}
        </span>
      </div>
      <div className="order-status border rounded-8 p-3 mt-2">
        <List
          type="inline"
          className="mb-0 d-flex align-items-start justify-content-between"
        >
          <ListInlineItem className={checkPending(orderLogisticStatus)}>
            <span className="status-icon d-inline-block">
              <BsCheckCircleFill size={16} />
            </span>
            <span className="d-block font-manrope f-12 fw-medium">Pending</span>
          </ListInlineItem>
          <ListInlineItem className={checkInProgress(orderLogisticStatus)}>
            <span className="status-icon d-inline-block">
              <BsCheckCircleFill size={16} />
            </span>
            <span className="d-block font-manrope f-12 fw-medium">
              Inprogress
            </span>
          </ListInlineItem>
          <ListInlineItem className={checkLoading(orderLogisticStatus)}>
            <span className="status-icon d-inline-block">
              <BsCheckCircleFill size={16} />
            </span>
            <span className="d-block font-manrope f-12 fw-medium">Loading</span>
          </ListInlineItem>

          <ListInlineItem className={checkDispatched(orderLogisticStatus)}>
            <span className="status-icon d-inline-block">
              <BsCheckCircleFill size={16} />
            </span>
            <span className="d-block font-manrope f-12 fw-medium">
              Dispatched
            </span>
            {/* <span className="d-block font-manrope date text-active fw-medium f-12">
              {dispatchDate && moment(dispatchDate).format('D MMM YYYY')}
            </span> */}
          </ListInlineItem>
          <ListInlineItem className={deliveryStatus(orderLogisticStatus)}>
            <span className="status-icon d-inline-block">
              <BsCheckCircleFill size={16} />
            </span>
            <span className="d-block font-manrope f-12 fw-medium">
              Delivered
            </span>
            {/* <span className="d-block font-manrope date text-active fw-medium f-12">
              {deliveryDate && moment(deliveryDate).format('D MMM YYYY')}
            </span> */}
          </ListInlineItem>
        </List>
      </div>
      {cancellationReason && (
        <div className="f-12 fw-medium">
          Cancel Reason
          <span className="font-manrope text-gray f-12 fw-semibold d-block">
            {cancellationReason}
          </span>
        </div>
      )}
      <div className="my-1">
        <Label className="text-gray f-12 text-uppercase fw-medium">
          Delivered By
        </Label>
        <span className="font-manrope f-12 fw-semibold d-block">
          {`${driverName ? driverName : 'N/A'}`}{' '}
          {driverNumber ? `${callingCode?.callingCode} ${driverNumber}` : ''}
        </span>
      </div>
      <div className="order-status border rounded-8 p-3 mt-2">
        <h4 className="f-12 text-uppercase fw-medium mb-2">Charges</h4>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Freight</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(freight, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Loading charges</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(loadingCharges, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Label className="f-12 fw-medium">Other Charges</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {`${currencyToLocal(otherCharges, rateUnit?.isoCurrencyCode)}`}
            </span>
          </Col>
        </Row>
      </div>

      <div className="order-status border rounded-8 p-3 mt-3 mb-3">
        <h4 className="f-12 text-uppercase fw-medium mb-2">Vehicle</h4>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Number</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {(vehicleNumber && (
                <span className="text-uppercase">{vehicleNumber}</span>
              )) ||
                'N/A'}
              {/* <Button
                color="link"
                className="text-decoration-none font-manrope fw-semibold f-12 ms-1 p-0"
              >
                -
              </Button> */}
            </span>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Name</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {transportName || 'N/A'}
            </span>
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Vehicle Number Image</Label>
          </Col>
          <Col sm={4}>
            {vehicleNumberImage?.[0]?.length ? (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                <Button
                  color="link"
                  className="text-decoration-none font-manrope fw-semibold f-12 p-0"
                  onClick={() =>
                    downloadImage(
                      vehicleNumberImage[0],
                      vehicleNumberImage[0] &&
                        splitNameFromUrl(vehicleNumberImage[0]),
                    )
                  }
                >
                  {splitNameFromUrl(vehicleNumberImage[0])}
                </Button>
              </span>
            ) : (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                N/A
              </span>
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Weight Slip</Label>
          </Col>
          <Col sm={4}>
            {/* <span className="font-manrope text-gray f-12 fw-semibold d-block">
              <Button
                color="link"
                className="text-decoration-none font-manrope fw-semibold f-12 p-0 text-start"
              >
                {splitNameFromUrl(weightSlipDoc[0])}
              </Button>
            </span> */}

            {weightSlipDoc?.[0]?.length ? (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                <Button
                  color="link"
                  className="text-decoration-none font-manrope fw-semibold f-12 p-0"
                  onClick={() =>
                    downloadImage(
                      weightSlipDoc[0],
                      weightSlipDoc[0] && splitNameFromUrl(weightSlipDoc[0]),
                    )
                  }
                >
                  {splitNameFromUrl(weightSlipDoc[0])}
                </Button>
              </span>
            ) : (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                N/A
              </span>
            )}
          </Col>
        </Row>
        <Row className="mb-2">
          <Col sm={4}>
            <Label className="f-12 fw-medium">Transport LR</Label>
          </Col>
          <Col sm={4}>
            <span className="font-manrope text-gray f-12 fw-semibold d-block">
              {transportLR || 'N/A'}
            </span>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <Label className="f-12 fw-medium">Loading</Label>
          </Col>
          <Col sm={4}>
            {loadingImage?.[0]?.length ? (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                <Button
                  color="link"
                  className="text-decoration-none font-manrope fw-semibold f-12 p-0"
                  onClick={() =>
                    downloadImage(
                      loadingImage[0],
                      loadingImage[0] && splitNameFromUrl(loadingImage[0]),
                    )
                  }
                >
                  {splitNameFromUrl(loadingImage[0])}
                </Button>
              </span>
            ) : (
              <span className="font-manrope text-gray f-12 fw-semibold d-block">
                N/A
              </span>
            )}
          </Col>
        </Row>
      </div>
    </CommonCollapse>
  );
};

export default DeliveryStatus;
